<template>
  <div id="location">
    <span
      @click.prevent="getCurrentPosition()"
      @mousedown="isActive = true"
      @touchstart="isActive = true"
      @mouseup="isActive = false"
      @touchend="isActive = false"
      @mouseout="isActive = false"
      @touchcancel="isActive = false"
      :class="{ 'is-active': isActive }"
    >
      <img
        src="@/assets/images/btn-present-location.svg"
        onselectstart="return false;"
        onmousedown="return false;"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import L from 'leaflet';

export default defineComponent({
  name: 'Location',
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.$store.dispatch(
              'setMyLocation',
              Object.assign(
                L.latLng(position.coords.latitude, position.coords.longitude),
                { __isDeviceLocation: true }
              )
            );
          },
          () => {},
          {
            timeout: 10000,
            enableHighAccuracy: true
          }
        );
      }
    }
  }
});
</script>

<style scoped lang="scss">
#location {
  span {
    cursor: pointer;

    img {
      width: 54px;
      height: 54px;
      box-shadow: 2px 2px 6px #00000029;
      border-radius: 27px;
      user-select: none;
      -webkit-touch-callout: none;
    }

    &.is-active {
      img {
        filter: brightness(0.7);
      }
    }
  }
}
</style>
